import type { SVGProps } from 'react';

const ReactComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 128 32"
    {...props}
  >
    <circle
      r={11}
      fill="var(--color-primary-main)"
      transform="translate(16 16)"
    >
      <animateTransform
        additive="sum"
        attributeName="transform"
        dur="1350ms"
        repeatCount="indefinite"
        type="scale"
        values="1;1.42;1;1;1;1;1;1;1;1"
      />
    </circle>
    <circle
      r={11}
      fill="var(--color-primary-main)"
      transform="translate(64 16)"
    >
      <animateTransform
        additive="sum"
        attributeName="transform"
        dur="1350ms"
        repeatCount="indefinite"
        type="scale"
        values="1;1;1;1;1.42;1;1;1;1;1"
      />
    </circle>
    <circle
      r={11}
      fill="var(--color-primary-main)"
      transform="translate(112 16)"
    >
      <animateTransform
        additive="sum"
        attributeName="transform"
        dur="1350ms"
        repeatCount="indefinite"
        type="scale"
        values="1;1;1;1;1;1;1;1.42;1;1"
      />
    </circle>
  </svg>
);
export { ReactComponent };
